import { useEffect, type CSSProperties, type ReactNode } from 'react';

type Props = {
  open: boolean;
  onClose?: () => void;
  children: ReactNode;
  backdrop?: boolean;
  backdropOpacity?: number;
  closeOnEsc?: boolean;
  closeOnBackdrop?: boolean;
  zIndex?: number;
  style?: CSSProperties;
};

export function Overlay({
  open,
  onClose,
  children,
  backdrop = true,
  backdropOpacity = 0.6,
  closeOnEsc = true,
  closeOnBackdrop = true,
  zIndex = 1000,
  style,
}: Props) {
  useEffect(() => {
    if (!open || !closeOnEsc) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, closeOnEsc, onClose]);

  if (!open) return null;

  return (
    <div
      role="presentation"
      onClick={closeOnBackdrop ? onClose : undefined}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex,
        background: backdrop ? `rgba(3, 5, 8, ${backdropOpacity})` : 'transparent',
        backdropFilter: backdrop ? 'blur(4px)' : undefined,
        display: 'flex',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
